import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocName: "",
    A_VocNo: 0,
    A_VocDt: new Date(),
    A_Loc: "",
    LocName: "",
    A_AcCd: "",
    A_AcName: "",
    A_CrLimit: 0,
    A_OsAmt: 0,
    A_MainGrp: "",
    MainGrpName: "",
    A_SubGrp: "",
    SubGrpName: "",
    A_Grp: "",
    GrpName: "",
    A_Brand: "",
    BrandName: "",
    A_LeadDays: 0,
    A_DocStat: "ENTER",
    A_DCLoc: "",
    DCLocName: "",
    PrmCd: "",
    A_CNSM_Type: "Regular",
    A_CNSM_From: new Date(),
    A_CNSM_To: new Date(),
    A_Total_Val: 0,
    WHLoc: [
      // {L_Chk: "Y", UId: "01", Name1: "RAHA"}
    ],
  },
};

const SliceDCRequest = createSlice({
  name: "SliceDCRequest",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_DCRequest_Init: (state) => {
      state.value = initialState;
    },
    //RESET HEAD
    Set_DCRequest_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },
    Set_DCRequest_HeadObject: (state, action) => {
      state.value.HeadObject = action.payload;
    },
    Set_DCRequest_HeadObject_WHLoc: (state, action) => {
      state.value.HeadObject.WHLoc = action.payload;
    },
    Set_DCRequest_HeadObject_VocNo_DocSt: (state, action) => {
      state.value.HeadObject.A_VocNo = action.payload.A_VocNo;
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_DCRequest_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObject.A_DocStat = action.payload.A_DocStat;
    },
    Set_DCRequest_HeadObject_A_Total_Val: (state, action) => {
      state.value.HeadObject.A_Total_Val = action.payload.A_Total_Val;
    },

    Set_DCRequest_HeadObject_CrLimit_OSAmt: (state, action) => {
      state.value.HeadObject.A_CrLimit = action.payload.A_CrLimit;
      state.value.HeadObject.A_OsAmt = action.payload.A_OsAmt;
    },
    Set_DCRequest_HeadObject_New_Set: (state, action) => {
      // A_VocTyp:  sDocumentTypeData[0]?.VocTyp,
      // A_VocName:  sDocumentTypeData[0]?.VocName,
      // A_Loc: sLoactionData[0]?.Cd,
      // LocName: sLoactionData[0]?.Name1,
      // WHLoc: sLoactionData[0]?.Stores,
      // A_DCLoc:sDCLoactionData[0]?.UId,
      // DCLocName:sDCLoactionData[0]?.UId,
      // A_CrLimit: iOsAmt,
      // A_OsAmt: iCrLimitAmt,
      state.value.HeadObject.A_VocTyp = action.payload.A_VocTyp;
      state.value.HeadObject.A_VocName = action.payload.A_VocName;
      state.value.HeadObject.A_Loc = action.payload.A_Loc;
      state.value.HeadObject.LocName = action.payload.LocName;
      state.value.HeadObject.WHLoc = action.payload.WHLoc;
      state.value.HeadObject.A_DCLoc = action.payload.A_DCLoc;
      state.value.HeadObject.DCLocName = action.payload.DCLocName;
      state.value.HeadObject.A_CrLimit = action.payload.A_CrLimit;
      state.value.HeadObject.A_OsAmt = action.payload.A_OsAmt;
    },
  },
});

export const {
  Set_DCRequest_Init,
  Set_DCRequest_HeadObject,
  Set_DCRequest_HeadObject_WHLoc,
  Set_DCRequest_HeadObject_New_Set,
  Set_DCRequest_HeadObject_Init,
  Set_DCRequest_HeadObject_VocNo_DocSt,
  Set_DCRequest_HeadObject_A_Total_Val,
  Set_DCRequest_HeadObject_A_DocStat,
  Set_DCRequest_HeadObject_CrLimit_OSAmt,
} = SliceDCRequest.actions;
export default SliceDCRequest.reducer;
